import type { TableColumn } from '../../types/MTT';

import {
  CELL_BUY_IN,
  CELL_GAME,
  CELL_NAME,
  CELL_PLAYERS,
  CELL_PRIZE_POOL,
  CELL_START_STATE
} from './columnsConfig';

export const columns: TableColumn[] = [
  { ...CELL_START_STATE, width: 160 },
  { ...CELL_NAME, width: 148 },
  { ...CELL_GAME, width: 100 },
  { ...CELL_BUY_IN, width: 70 },
  { ...CELL_PRIZE_POOL, width: 90 },
  { ...CELL_PLAYERS, width: 70 }
];

export default columns;
